<template>
  <div id="app" >
    <div class="theme-green ">
      <router-view v-if="isRouterAlive"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true,
    }
  },  
  methods: {
    reload() {  //重载当前页
      let self = this;
      this.isRouterAlive = false;
      this.$nextTick(function() {
        self.isRouterAlive = true;
      })
    },    
  }
}
</script>
<style scoped>

.bgClolor{
  background-color: #000;
}

</style>





// WEBPACK FOOTER //
// src/App.vue